import React, { useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails, Stack
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FeuillesTempsHebdoDayCell from './FeuillesTempsHebdoDayCell';
import {helper} from "../../../../utils/helper.js";

function FeuillesTempsHebdoWeekTable({ semaine, operateurId, operateurLibelle, periodeId }) {
    const { numero, annee, debut, fin, jours, totaux } = semaine;
    const [expanded, setExpanded] = useState(true);

    const handleAccordionChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion 
            expanded={expanded} 
            onChange={handleAccordionChange}
            sx={{ mb: 3, width: '100%' }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`week-${numero}-content`}
                id={`week-${numero}-header`}
                sx={{ 
                    backgroundColor: '#f5f5f5',
                    '&.Mui-expanded': {
                        minHeight: '48px',
                    },
                    width: '100%'
                }}
            >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%"
                  }}
                >
                    <Box>
                        <Typography variant="h6">
                            Semaine {numero} ({helper.formatDate(debut)} - {helper.formatDate(fin)})
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Typography variant="body2">
                            <strong>HN:</strong> {totaux.hn.toFixed(2)}h
                        </Typography>
                        <Typography variant="body2">
                            <strong>H25:</strong> {totaux.h25.toFixed(2)}h
                        </Typography>
                        <Typography variant="body2">
                            <strong>H50:</strong> {totaux.h50.toFixed(2)}h
                        </Typography>
                        <Typography variant="body2">
                            <strong>HNuit:</strong> {totaux.hnuit.toFixed(2)}h
                        </Typography>
                        <Typography variant="body2">
                            <strong>Total:</strong> {totaux.total.toFixed(2)}h
                        </Typography>
                    </Box>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Jour</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Heure Début</TableCell>
                                <TableCell>Heure Fin</TableCell>
                                <TableCell>Pause</TableCell>
                                <TableCell>Équipier</TableCell>
                                <TableCell>Laveuse</TableCell>
                                <TableCell>Tournée</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {jours.map((jour, index) => (
                                <FeuillesTempsHebdoDayCell 
                                    key={index} 
                                    jour={jour} 
                                    operateurId={operateurId}
                                    operateurLibelle={operateurLibelle}
                                    periodeId={periodeId}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </AccordionDetails>
        </Accordion>
    );
}

export default FeuillesTempsHebdoWeekTable;
